import db from "../../database";
import * as msg from "../../message";
import * as helper from "../../helper";
let bcrypt = require("bcryptjs");
import store from "../../store/index";

export const Auth = (data) => {
  return new Promise((resolve, reject) => {
    console.log("[ Offline ]: Auth Start");
    let response = {
      data: {},
    };
    db.transaction("rw", db.user, async () => {
      await db.user
        .where("mobile")
        .equals(data.mobile)
        .first()
        .then((item) => {
          if (!(item instanceof Object)) {
            response.data.status = "account_not_active";
            response.data.message = msg.USER_NOT_EXISTS;
          } else {
            response.data = {
              data: {
                v_id: item.v_id,
                vu_id: item.id,
              },
            };
            response.data.status = "login_redirect";
          }
        });
    })
      .then(() => resolve(response))
      .catch((err) => {
        store.dispatch("system/log", {
          type: "register_user",
          log: { name: err.name, message: err.message, mob: data.mobile },
          response: err.stack,
          status: "error",
        });
        alertData();
        reject(response);
      });
  });
};

export const Login = (data) => {
  return new Promise((resolve, reject) => {
    console.log("[ Offline ]: Login");
    let response = {
      data: {},
    };

    if (store.state.system.isOffline == false) {
      return Promise.resolve(response);
    }

    db.transaction("rw", db.user, db.setting, async () => {
      await db.user
        .where("mobile")
        .equals(data.mobile)
        .first()
        .then((item) => {
          let hash1 = item.password;
          if (bcrypt.compareSync(data.pin, hash1)) {
            db.setting
              .where("user_id")
              .equals(parseInt(item.id))
              .first()
              .then((sett) => {
                const token = helper.makeid(60);
                item.api_token = token;
                response.data = {
                  data: item,
                };
                if (!response.data.data.hasOwnProperty("vu_id")) {
                  response.data.data = Object.assign(
                    {
                      vu_id: response.data.data.id,
                      terminal_id: sett.terminal_id,
                    },
                    response.data.data
                  );
                }
                if (sett.settings.hasOwnProperty("settings"))
                  response.data.settings = sett.settings.settings;
                else response.data.settings = sett.settings;
                response.data.status = "login_redirect";
              });
          } else {
            response.data.status = "invalid_credentials";
            response.data.message = msg.USER_NOT_EXISTS;
          }
        });
    })
      .then(() => resolve(response))
      .catch((err) => {
        store.dispatch("system/log", {
          type: "user_login",
          log: { name: err.name, message: err.message, mob: data.mobile },
          response: err.stack,
          status: "error",
        });
        alertData();
        reject(response);
      });
  });
};

export const Logout = (data) => {
  return new Promise((resolve) => resolve(data));
};

function alertData() {
  let alertData = {
    message: msg.INTERNAL_SERVER_ERROR,
    type: "danger",
  };
  store.commit("notifications/showAlert", alertData);
}
